<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/stores/user'
import Auth from '@/api/Auth.js'
import User from '@/api/User.js'

const router = useRouter()

// components 
let email = ref('');
let status = ref('');
let isSubmitting = ref(false);
let success = ref(false)
let message = ref("")

async function pwResetRequest() {
    isSubmitting.value = true
    // const { data } = await axios.get(context.env.apiUrl + "/api/services"); 
    // should send a verification email ---- 2FA??
    // let {data} = await Auth.register(this.email, this.password)
    let data  = await User.request_password_reset(email.value)

    isSubmitting.value = false
    
    if(data.status) {
        success.value = true;            
    } else {
        message.value = data.message
    }
}

</script>

<template>
  <div class="login-container">
      <div class="box bordered p-5">
        <div v-if="!success">
          <h3 class="mb-4 jura text-center">Reset password</h3>
          <div class="text-center mb-4">Dont have an account? &nbsp;<router-link to="/signup" class="link" style="color: white !important;">Sign up</router-link> </div>
          <p v-if="!success" class="ms-1 danger mb-4">{{message}}</p>
          <form action="#" @submit.prevent="pwResetRequest()" class="form-floating mb-4">
              <div class="form-floating mb-3">
                  <input type="email" v-model="email" class="form-control dark" id="floatingInput" placeholder="name@example.com">
                  <label for="floatingInput">Email address</label>
              </div>
              <button  v-if="!isSubmitting" :disabled="!email" type="submit" class="btn btn-primary submit-btn">Continue</button>
              <button  v-else disabled type="submit" class="btn btn-primary submit-btn">Sending reset instructions...</button>
          </form>
        </div>
        <div v-else>
          <h3 class="mb-4 jura text-center">Instructions sent!</h3>
          <div class=" mb-3">We have sent an email to {{ email }} with instructions for completing your password reset. You will have 10 minutes to complete the reset, otherwise you will need to request a new email.</div>
          <p class="mb-4">If you encounter any issues, don't hesitate to reach out to our <a href="mailto:support@webscout.io">support team</a></p>
          <div class="text-center"><router-link to="/login" class="link" style="color: inherit;">Go to login</router-link> </div>
        </div>
      </div>

  </div>
</template>


<style scoped>
.login-container {
  width: 450px;
}

.wrapper {
    background-image: url('~@/assets/split-map.svg');
    background-repeat: no-repeat;
    background-position: 0;
    background-position-x: 100%;
    background-size: 55%;
}

.danger {
    color: var(--color-error-text);
    font-size: 1rem;
}

.submit-btn {
    height: 64px;
    background-color: var(--surface-raised);
    font-size: 1rem;
    outline:none;
    width: 100%;
    box-shadow: none;
    border:none;
    border-radius: var(--radius-md);
}

#submit-btn:hover {
    background-color: #36404F;
}

.link:hover {
  text-decoration: underline;
}
</style>
